import { getContactsWithFilters } from '../services/ContactService';

/** Conteúdo persistido pelo backend/WhatsApp: "📇 Nome\n📞 telefone" */

export function parseContactShareContent(content: string | null | undefined): { name: string; phoneRaw: string } {
  const text = (content || '').trim();
  let name = 'Contato';
  let phoneRaw = '';
  const lines = text.split('\n').map((l) => l.trim());
  for (const line of lines) {
    if (line.startsWith('📇')) {
      const n = line.replace(/^📇\s*/, '').trim();
      if (n) name = n;
    }
    if (line.startsWith('📞')) {
      phoneRaw = line.replace(/^📞\s*/, '').trim();
    }
  }
  return { name, phoneRaw };
}

export function phoneDigitsOnly(s: string): string {
  return (s || '').replace(/\D/g, '');
}

/** API exige 10–13 dígitos (ver CreateContact no serviço Go). */
export function formatPhoneForCreateContact(displayOrRaw: string): string | null {
  let d = phoneDigitsOnly(displayOrRaw);
  if (d.length > 13) {
    d = d.slice(-13);
  }
  if (d.length < 10 || d.length > 13) {
    return null;
  }
  return d;
}

export function contactMatchesPhone(contactNumber: string | undefined, digits: string): boolean {
  if (!digits || digits.length < 8) return false;
  const a = phoneDigitsOnly(contactNumber || '');
  const b = digits;
  if (!a) return false;
  if (a === b) return true;
  if (a.endsWith(b) || b.endsWith(a)) return true;
  const tailA = a.slice(-11);
  const tailB = b.slice(-11);
  if (tailA.length >= 10 && tailB.length >= 10 && tailA === tailB) return true;
  return false;
}

/**
 * Busca no servidor um contato do setor pelo telefone (ativos + arquivados).
 * Evita falhas quando a lista local ainda não foi atualizada ou o número não casa com o estado local.
 */
export async function findContactByDigitsOnServer(sectorId: number, digits: string): Promise<any | null> {
  if (!digits || digits.length < 8) return null;
  try {
    const data = await getContactsWithFilters(sectorId, true, false);
    const rawList = Array.isArray(data) ? data : (data as any)?.data || [];
    return rawList.find((c: any) => contactMatchesPhone(c.number, digits)) ?? null;
  } catch {
    return null;
  }
}
